{
  "cl_header": {
    "logout": "Ausloggen"
  },
  "cl_applauncher": {
    "seemoreapplications": "Sehen Sie mehr Anwendungen",
    "spinner": "Wird geladen...",
    "noApps": "Keine Apps vorhanden"
  },
  "cl_alert": {
    "dismiss_all": "Alle Ablehnen",
    "notfication_title": "Benachrichtigungen",
    "no_notifications": "Keine Benachrichtigungen"
  },
  "cl_side_nav": {
    "support": "Unterstützung",
    "legal": "Legal"
  },
  "cl_company_switcher": {
    "search_company": "Firmenname",
    "loading": "Wird geladen"
  },
  "applauncher": {
    "spinner": "Wird geladen..."
  }
}
